import React from "react";
import { ExternalLink } from "lucide-react";

// GDPR-friendly map embed via OpenStreetMap iframe (no API key, no tracking,
// no cookies). Coordinates: Wildenstrasse 3, 8212 Neuhausen am Rheinfall.
const LAT = 47.6822;
const LON = 8.6174;
const ZOOM_DELTA = 0.006; // ~600 m view

export default function LocationMap({ label = "Hauptsitz MBW Swiss AG", testId = "location-map" }) {
  const bbox = `${LON - ZOOM_DELTA},${LAT - ZOOM_DELTA / 2},${LON + ZOOM_DELTA},${LAT + ZOOM_DELTA / 2}`;
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${LAT},${LON}`;
  const fullMap = `https://www.openstreetmap.org/?mlat=${LAT}&mlon=${LON}#map=17/${LAT}/${LON}`;
  const directions = `https://www.google.com/maps/dir/?api=1&destination=${LAT},${LON}`;

  return (
    <div className="bg-white rounded-2xl overflow-hidden border border-slate-200" data-testid={testId}>
      <iframe
        title={label}
        src={src}
        className="w-full h-72 md:h-80 border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
      <div className="px-5 py-3 flex flex-wrap items-center justify-between gap-3 text-sm border-t border-slate-200">
        <div className="text-slate-600">
          <span className="font-semibold text-[#1A2433]">{label}</span> · Wildenstrasse 3, 8212 Neuhausen am Rheinfall
        </div>
        <div className="flex gap-4 text-[#991B1B] font-medium">
          <a href={directions} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 hover:underline" data-testid="map-directions">
            Route planen <ExternalLink className="w-3.5 h-3.5" />
          </a>
          <a href={fullMap} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 hover:underline" data-testid="map-larger">
            Grössere Karte <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </div>
  );
}
